import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    useTheme,
    TextField, Alert, Box
} from "@mui/material";
import React, {useState} from "react";
import {useForm} from "react-hook-form";
import PropTypes from "prop-types";
import Spinner from "../../spinner/Spinner";
import {connect} from "react-redux";
import {alertActions} from "../../../store/actions/alertActions";
import {apiAccessServices} from "../../../service/apiAccessService";
import {SettingsDialog as Dialog, SettingsDialogDescription} from "../SettingsDialog";
import {apiAccessActions} from "../../../store/actions/apiAccessAction";

export function CreateAccessTokenForm(props) {

    const {onClose, open, successMsg, clear, reload} = props;

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const [loading, setLoading] = useState(false);

    const {register, handleSubmit, formState: {errors}, reset} = useForm();
    const [formError, setFormError] = useState("");

    const onSubmit = async (data) => {
        setLoading(true);
        setFormError("");
        let formData = {
            name: data?.name
        };

        await apiAccessServices.create(formData).then(() => {
            setLoading(false);
            successMsg("Access token successfully generated.");
            reload();
            handleClose();
        }).catch((e) => {
            setFormError(e?.response?.data?.error || "Unable to generate an access token. Please try again.");
            setLoading(false);
        });
    };

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return false;
        }

        setTimeout(() => {
            clear();
        }, 3000);

        reset();
        setFormError("");
        onClose();
    };

    return (
        <Dialog open={open}
                onClose={handleClose}
                fullWidth={true}
                fullScreen={fullScreen}
                aria-labelledby="create-access-token-form"
                maxWidth={"sm"}
        >
            <DialogTitle id="create-access-token-form">Create API access token
                <SettingsDialogDescription>Give your token a name so you can recognize the tool or integration using it.</SettingsDialogDescription>
            </DialogTitle>
            <DialogContent>
                {formError && <Alert severity="error" variant="filled" sx={{mb: 2}}>{formError}</Alert>}
                <form onSubmit={handleSubmit(onSubmit)} autoComplete={"off"}>
                    <TextField
                        autoFocus
                        error={!!errors?.name}
                        helperText={errors?.name ? "Enter a token name (up to 100 characters)." : undefined}
                        disabled={loading}
                        type="text"
                        variant="outlined"
                        margin="dense"
                        size="small"
                        label="Name"
                        name="name"
                        fullWidth
                        id="name"
                        placeholder="Enter access token name"
                        slotProps={{
                            inputLabel: {
                                shrink: true
                            }
                        }}
                        {...register("name", {required: true, maxLength: 100, minLength: 1})}
                    />
                    <Box sx={{mt: 2, color: "text.secondary", fontSize: 13}}>Access tokens expire one year after creation. Keep your token private.</Box>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit" disabled={loading}>
                    Cancel
                </Button>
                {loading ? <Spinner/> :
                    <Button onClick={handleSubmit(onSubmit)} color="primary" variant="contained" disabled={loading}>
                        Generate
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
}

CreateAccessTokenForm.prototype = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => {
    return {
        state: {
            alert: state.alert,
        }
    };
};

const mapDispatchToProps = {
    errorMsg: alertActions.error,
    successMsg: alertActions.success,
    clear: alertActions.clear,
    reload: apiAccessActions.reload
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAccessTokenForm);